import FAB from 'components/FAB';
import Layout from 'components/Layout';
import Info from 'components/Blocks/Info';
import FAQ from 'components/Blocks/FAQ';
import Landing from 'components/Blocks/Landing';
import Story from 'components/Blocks/Story';
import Benefit from 'components/Blocks/Benefit';
import RoadMap from 'components/Blocks/RoadMap';
import withRouteChangeTracker from 'GA/withRouteChangeTracker';

const Index = () => {
  return (
    <>
      <Layout>
        <Landing id='landing' />
        <Story id='story' />
        <Benefit id='benefit' />
        <Info id='info' />
        <RoadMap id='road-map' />
        <FAQ id='faq' />
      </Layout>
      <FAB />
    </>
  );
};

export default withRouteChangeTracker(Index);
